import React from 'react';
import RiderNavigation from './RiderNavigation';

function RiderLayout({ children }) {
  return (
    <div className="min-h-screen bg-gray-100">
      <RiderNavigation />
      <main className="py-6">
        {children}
      </main>
    </div>
  );
}

export default RiderLayout; 